import { AxiosResponse } from 'axios';
import { serverAxios } from '../../http';
import { HttpTimeoutPriority } from 'utils/enums/http-timeout-priority';
import { IGetSimpleListFilters, IGetSimpleListResponse } from 'models/http/common';

class RateGroupHttp {
  private static route = '/rateGroup';

  public async getSimple(_?: IGetSimpleListFilters, abortController?: AbortController): Promise<IGetSimpleListResponse> {
    return serverAxios
      .get(`${RateGroupHttp.route}/simple`, {
        signal: abortController?.signal,
        timeout: HttpTimeoutPriority.Medium,
      })
      .then((response: AxiosResponse<IGetSimpleListResponse>) => {
        return response.data;
      });
  }
}

export default RateGroupHttp;
